import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/TAYKUS.svg'
import _imports_1 from '../../assets/images/arrow-prev.svg'


const _withScopeId = n => (_pushScopeId("data-v-1d9a0785"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "relative w-full" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "absolute w-full",
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_2 = { class: "flex justify-between relative" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "slide-position flex" }
const _hoisted_6 = {
  key: 2,
  class: "next-button absolute w-full cursor-pointer"
}
const _hoisted_7 = { class: "relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenderSelector = _resolveComponent("GenderSelector")!
  const _component_InputLevel = _resolveComponent("InputLevel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("header", _hoisted_2, [
      (_ctx.selectedValue != 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.moveIndicator(-1))),
            class: "cursor-pointer back-button h-8 w-8 flex justify-center items-center"
          }, _hoisted_4))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indicators, (indicator, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass([
          'indicator h-1 w-full',
          { 'select-indicator': index === _ctx.selectedValue },
        ])
          }, null, 2))
        }), 128))
      ])
    ]),
    (_ctx.selectedValue == 0)
      ? (_openBlock(), _createBlock(_component_GenderSelector, {
          key: 0,
          onShowNextStep: _ctx.moveIndicator,
          propGender: _ctx.soccer[1],
          onSelectedGender: _ctx.handleSelectedOption
        }, null, 8, ["onShowNextStep", "propGender", "onSelectedGender"]))
      : _createCommentVNode("", true),
    (_ctx.selectedValue == 1)
      ? (_openBlock(), _createBlock(_component_InputLevel, {
          key: 1,
          onShowNextStep: _ctx.moveIndicator,
          min: _ctx.minLevel,
          max: _ctx.maxLevel,
          sport: _ctx.Sport.SOCCER,
          modelValue: _ctx.level,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.level) = $event)),
          onLevel: _ctx.handleLevel
        }, null, 8, ["onShowNextStep", "min", "max", "sport", "modelValue", "onLevel"]))
      : _createCommentVNode("", true),
    (_ctx.selectedValue < 6)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("img", {
              class: "button-next-img absolute",
              src: _imports_1,
              alt: "",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.moveIndicator(1)))
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}